module.exports = __webpack_public_path__ + "img/picto-facebook.6e0e3d0c.svg";